import React from "react";
import { useSelector } from "react-redux";
import ShopByDepartment from "./ShopByDepartment/index";
import NavMenu from "./NavMenu/index";
import "./navigation-bar-theme2.scss";
import AppStoreImage from "../../../assets/icons/app-store.svg";
import GoogleStoreImage from "../../../assets/icons/google-pay.svg";
import { Link } from "react-router-dom";
import { getLocalStorageValue } from "config/helper";

const NavigationBar = () => {
  const { reorder_section } = useSelector(
    ({ common }) => common.commonDetailsData
  );
  const { ios_app_url, android_app_url } = useSelector(
    ({ common }) => common.commonDetailsData.header_section
  );
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

  const { storeListData } = useSelector(({ store }) => store);
  const selectedStore =
    storeListData &&
    storeListData.find(
      (store) =>
        store.ClientStoreId === getLocalStorageValue("selected-store-id")
    );

  const { allow_ecommerce = "1" } = selectedStore || {};

  return (
    <div className="navigation-bar-theme2 navigation-bar-theme2">
      <div className="container">
        <div className={`navigation-bar-wrapper ${allow_ecommerce === "1" ? '' : 'padding-top-bottom-12px'}`}>
          <div className="menu">
            <NavMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;
